export const isProPBSystem = process.env?.REACT_APP_TITLE?.includes('роектов');
